
define(
	'Code25.CaterpartsGlobal.Sidebar'
	, [
		"Utils"
	]
	, function (
		Utils
	) {
		'use strict';
		return {
			mount: function mount(container) {

				var HeaderMenuView = require("Header.Menu.View");
				if (HeaderMenuView) {
					
					HeaderMenuView.prototype.closeSidebar=function(){
						var mainEl = $('#main');
							if (mainEl.hasClass('header-sidebar-opened')) {
								mainEl.removeClass('header-sidebar-opened');
							}
						
					}
					
					HeaderMenuView.prototype.events['click [data-action="close-sidebar"]']= 'closeSidebar';
					
				}
			}

		}

	});
